<template>
    <section v-if="show">
        <div class="row pb-5">
            <div class="col">
                {{ $t('auth.closed-shop-info') }}
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AuthClosedShopInfoBox',
    computed: {
        show(){
            return this.$root.whitelabel.setting('accessibility') === 'closed' || this.$root.whitelabel.setting('is_b2b')
        }
    },
}
</script>
